import axios from "axios";
import router from "@/router";

//  ดึง URL จากไฟล์ .env อัตโนมัติ (รองรับทั้ง Vue CLI และ Vite)
const API_URL =
  process.env.VUE_APP_API_URL || import.meta.env?.VUE_APP_API_URL || "";

const adminApi = axios.create({
  baseURL: API_URL, // <--- เปลี่ยนจากพิมพ์สด เป็นการใช้ตัวแปรจาก .env ครับ
  headers: {
    "Content-Type": "application/json",
  },
});

// เพิ่มฟังก์ชันสำหรับตั้งค่า Token โดยตรง (ไม่ต้องรอ LocalStorage)
export const setAuthToken = (token) => {
  if (token) {
    adminApi.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  } else {
    delete adminApi.defaults.headers.common["Authorization"];
  }
};

// Request Interceptor (ยังคงเก็บไว้เป็น Fallback)
adminApi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("admin_token");
    // ถ้าใน Header ยังไม่มี (จากการ setAuthToken) ให้ลองหาจาก LocalStorage
    if (token && !config.headers["Authorization"]) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

// Response Interceptor
adminApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // ถ้าเจอ 401 (Token หมดอายุหรือผิด)
      console.warn("Session expired or invalid. Redirecting to login...");

      // 1. เคลียร์ Token
      localStorage.removeItem("admin_token");
      localStorage.removeItem("admin_user");

      // 2. ดีดไปหน้า Login (ใช้ window.location เพื่อความเด็ดขาด)
      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  },
);

export default adminApi;
